<template>
  <div class="search-bar">
    <select v-model="selectedField">
      <option value="title">제목</option>
      <option value="content">내용</option>
    </select>
    <input
      type="text"
      v-model="searchKeyword"
      placeholder="검색어를 입력하세요"
      @keyup.enter="emitSearch"
    />
    <button @click="emitSearch">검색</button>
  </div>
</template>

<script setup>
import { ref } from "vue";

const selectedField = ref("title");
const searchKeyword = ref("");

const emit = defineEmits(["search"]);

const emitSearch = () => {
  emit("search", {
    field: selectedField.value,
    keyword: searchKeyword.value || "", // null이나 undefined 방지
  });
};
</script>

<style scoped>
.search-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
}
select,
input {
  padding: 6px 10px;
  font-size: 0.95rem;
}
input {
  width: 200px;
}
button {
  padding: 6px 12px;
  font-size: 0.95rem;
  background: #111;
  color: white;
  border: none;
  cursor: pointer;
}
button:hover {
  background: #333;
}
</style>
